import React from 'react';
import { isIOS } from 'react-device-detect';
import { createPortal } from 'react-dom';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import ModalHeader from 'components/ModalHeader';
import useIsDesktop from 'hooks/useIsDesktop';

import { Transition, Backdrop, Modal } from './styles';

export interface Props {
  show: boolean;
  noPadding?: boolean;
  title?: string;
  header?: JSX.Element;
  style?: React.CSSProperties;
  children: React.ReactNode;
  noHeader?: boolean;
  modal?: boolean;
  onClose: () => void;
  zIndex?: number;
  noScroll?: boolean;
  highlight?: boolean;
}

const BottomSheet = ({
  show,
  style,
  title,
  header,
  noPadding,
  noHeader,
  children,
  onClose,
  modal,
  zIndex = 10,
  noScroll = false,
  highlight = false,
}: Props) => {
  const isDesktop = useIsDesktop();

  const handleClose = () => {
    onClose();
  };

  if (isDesktop) {
    return (
      <ApplicationOverlayContent sidebar={!modal} show={show} onClose={handleClose} zIndex={zIndex}>
        {title && <ModalHeader title={title} onClose={handleClose} highlight={highlight} />}
        {children}
      </ApplicationOverlayContent>
    );
  }

  return createPortal(
    <Transition
      transitionName="bottom-fade"
      transitionEnterTimeout={400}
      transitionLeaveTimeout={300}
      style={{ zIndex }}
    >
      {show && (
        <Backdrop
          data-testid="bottom-sheet-backdrop"
          onClick={(event: React.MouseEvent) => {
            event.stopPropagation();
            handleClose();
          }}
          style={{ zIndex }}
        >
          <Modal data-testid="bottom-sheet-modal" style={style} ios={isIOS} noScroll={noScroll}>
            <Modal.Header onClick={(event: React.SyntheticEvent) => event.stopPropagation()}>
              {!noHeader && <Modal.Header.Dragger onClick={handleClose} />}
              {title ? (
                <Modal.Header.Title
                  data-testid="bottom-sheet-modal-header-title"
                  className={highlight ? 'highlight' : ''}
                >
                  {title}
                </Modal.Header.Title>
              ) : (
                header
              )}
            </Modal.Header>
            <Modal.Body
              styledProps={{ noPadding }}
              data-testid="bottom-sheet-modal-body"
              onClick={(event: React.SyntheticEvent) => event.stopPropagation()}
            >
              {children}
            </Modal.Body>
          </Modal>
        </Backdrop>
      )}
    </Transition>,
    document.body,
  );
};

export default BottomSheet;
